import { render } from "./upsert.vue?vue&type=template&id=6b25bfe7&scoped=true"
import script from "./upsert.vue?vue&type=script&lang=js"
export * from "./upsert.vue?vue&type=script&lang=js"

import "./upsert.vue?vue&type=style&index=0&id=6b25bfe7&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b25bfe7"]])

export default __exports__